/* Petit Souvenir: one optional perfume offer shared by both carts.
   2026-10-08 (Diego): the offer lives INSIDE the cart only (drawer card + cart page card). Checkout goes straight to
   checkout: the full-screen "Forgetting a little something?" reminder on the Checkout tap is off. It is kept, not
   deleted: pass `reminder: true` in the checkout options (everla-v2.js) to bring it back. With it off, the drawer's
   Checkout link is a plain link again, and the cart page's Checkout still saves the cart note first. */
(function (global) {
  'use strict';
  function createController(options) {
    var items = [], busy = false, added = false;
    function state() {
      return { visible: items.length > 0, added: added, disabled: busy || added || !options.available,
        label: busy ? 'Adding…' : added ? 'Added to your cart' : !options.available ? 'Sold out' : 'Add to my order' };
    }
    function render() { if (options.render) options.render(state()); }
    return {
      state: state,
      update: function (cart) { items = cart.items || []; added = items.some(function (item) { return String(item.variant_id) === String(options.variant); }); render(); },
      add: async function () {
        if (state().disabled) return false;
        busy = true; render();
        try { await options.add(); added = true; return true; }
        finally { busy = false; render(); }
      }
    };
  }
  function createCheckoutGuard(options) {
    var shown = options.wasShown(), checking = false, adding = false, pending = null;
    function containsPerfume(cart) { return (cart.items || []).some(function (item) { return String(item.variant_id) === String(options.variant); }); }
    function update(cart) { if (!(cart.items || []).length) { shown = false; options.setShown(false); } }
    function finish() { var proceed = pending; pending = null; options.close(); if (proceed) proceed(); }
    return {
      update: update,
      request: async function (proceed) {
        if (checking || adding || pending) return false;
        checking = true;
        var cart;
        try { cart = await options.getCart(); }
        catch (error) { checking = false; proceed(); return false; }
        checking = false; update(cart);
        if (!options.available || !(cart.items || []).length || containsPerfume(cart) || shown) { proceed(); return false; }
        pending = proceed; shown = true; options.setShown(true); options.open(); return true;
      },
      accept: async function () {
        if (!pending || adding) return false;
        adding = true; options.onBusy(true);
        try {
          // The cart may have changed in another tab while this dialog was open.
          var cart = await options.getCart();
          if ((cart.items || []).length && !containsPerfume(cart)) await options.add();
          finish(); return true;
        } catch (error) { options.onError(error); return false; }
        finally { adding = false; options.onBusy(false); }
      },
      skip: function () { if (!pending || adding) return false; finish(); return true; },
      cancel: function () { if (!adding) pending = null; }
    };
  }
  function init(addToCart, checkoutOptions) {
    var dialog = document.querySelector('[data-perfume-dialog]');
    if (!dialog) return null;
    var offers = Array.from(document.querySelectorAll('[data-perfume-offer]'));
    var buttons = Array.from(document.querySelectorAll('[data-perfume-add]'));
    var opener = null, scrollWasLocked = false, checkoutBusy = false, resumeForm = null;
    var checkoutGuard = null;
    var reminder = !!(checkoutOptions && checkoutOptions.reminder === true);
    var checkoutAdd = dialog.querySelector('[data-perfume-checkout-add]');
    var checkoutSkip = dialog.querySelector('[data-perfume-checkout-skip]');
    var closeButton = dialog.querySelector('[data-perfume-close]');
    var title = dialog.querySelector('#EverlaPerfumeTitle');
    var subtitle = dialog.querySelector('.ev-perfume-subtitle');
    var kicker = dialog.querySelector('.ev-perfume-kicker');
    var controller = createController({
      variant: dialog.dataset.variant, available: dialog.dataset.available === 'true',
      add: function () { return addToCart([{ id: Number(dialog.dataset.variant), quantity: 1 }]); },
      render: function (state) {
        offers.forEach(function (offer) { offer.hidden = !state.visible; });
        buttons.forEach(function (button) { button.disabled = state.disabled; button.textContent = state.label; });
      }
    });
    function clearErrors() { document.querySelectorAll('[data-perfume-error]').forEach(function (el) { el.textContent=''; }); }
    function showError(error) { document.querySelectorAll('[data-perfume-error]').forEach(function (el) { el.textContent=(error && (error.description || error.message)) || 'Could not add the perfume. Please try again or continue without it.'; }); }
    function open(mode, trigger) {
      opener = trigger; scrollWasLocked = document.body.classList.contains('ev-lock');
      var reminder = mode === 'checkout'; dialog.dataset.mode = mode;
      title.textContent = reminder ? 'Forgetting a little something?' : 'Petit Souvenir';
      subtitle.textContent = reminder ? 'Petit Souvenir · Floral Perfume' : 'Floral Perfume';
      kicker.textContent = reminder ? 'EVERLA · Before you go' : 'EVERLA · A scented finishing touch';
      dialog.querySelectorAll('[data-perfume-checkout-only]').forEach(function (el) { el.hidden = !reminder; });
      dialog.querySelectorAll('[data-perfume-details-only]').forEach(function (el) { el.hidden = reminder; });
      clearErrors(); dialog.showModal(); dialog.scrollTop = 0; document.body.classList.add('ev-lock');
    }
    function close() { if (dialog.open) dialog.close(); }
    function proceedAfterNote(proceed) {
      Promise.resolve().then(function () { return checkoutOptions.beforeCheckout && checkoutOptions.beforeCheckout(); }).catch(function () {}).then(proceed);
    }
    if (checkoutOptions && !reminder) {
      // Cart page: save the note, then let the form submit to checkout. No dialog, no cart fetch.
      document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!form.matches('[data-perfume-checkout-form]')) return;
        if (resumeForm === form) { resumeForm = null; return; }
        var submitter = event.submitter || form.querySelector('[name="checkout"]');
        if (submitter && submitter.name !== 'checkout') return;
        event.preventDefault();
        proceedAfterNote(function () {
          resumeForm = form;
          if (typeof form.requestSubmit === 'function') { form.requestSubmit(submitter); return; }
          // Very old browsers: a plain submit() skips the button, so name it.
          var flag = document.createElement('input'); flag.type = 'hidden'; flag.name = 'checkout'; flag.value = '1'; form.appendChild(flag); form.submit();
        });
      });
    }
    if (checkoutOptions && reminder && typeof dialog.showModal === 'function') {
      var storageKey = 'everla:perfume-checkout-reminder:v1';
      checkoutGuard = createCheckoutGuard({
        variant: dialog.dataset.variant, available: dialog.dataset.available === 'true',
        wasShown: function () { try { return sessionStorage.getItem(storageKey) === 'shown'; } catch (error) { return false; } },
        setShown: function (shown) { try { if (shown) sessionStorage.setItem(storageKey, 'shown'); else sessionStorage.removeItem(storageKey); } catch (error) {} },
        getCart: checkoutOptions.getCart,
        add: function () { return checkoutOptions.add([{ id: Number(dialog.dataset.variant), quantity: 1 }]); },
        open: function () { open('checkout', document.activeElement); }, close: close,
        onBusy: function (busy) { checkoutBusy=busy; checkoutAdd.disabled=busy; checkoutSkip.disabled=busy; closeButton.disabled=busy; checkoutAdd.textContent=busy ? 'Adding…' : 'Add for ' + dialog.dataset.price + ' & checkout'; },
        onError: showError
      });
      document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!form.matches('[data-perfume-checkout-form]')) return;
        if (resumeForm === form) { resumeForm = null; return; }
        var submitter = event.submitter || form.querySelector('[name="checkout"]');
        if (submitter && submitter.name !== 'checkout') return;
        event.preventDefault();
        checkoutGuard.request(function () { proceedAfterNote(function () { resumeForm=form; form.requestSubmit(submitter); }); });
      });
    }
    dialog.addEventListener('close', function () {
      if (checkoutGuard) checkoutGuard.cancel();
      if (!scrollWasLocked && !document.querySelector('.ev-cart.is-open')) document.body.classList.remove('ev-lock');
      if (opener && opener.isConnected && !opener.closest('[hidden]')) opener.focus();
    });
    // Keep Escape local to the top dialog, leaving the underlying cart open.
    dialog.addEventListener('keydown', function (event) { if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); if (!checkoutBusy) close(); } });
    dialog.addEventListener('click', function (event) { if (event.target === dialog && !checkoutBusy) { var rect=dialog.getBoundingClientRect(); if(event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom) close(); } });
    document.addEventListener('click', function (event) {
      var checkout = event.target.closest('[data-ev-checkout]');
      if (checkout && checkoutGuard && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
        event.preventDefault(); checkoutGuard.request(function () { proceedAfterNote(function () { window.location.assign(checkout.href); }); }); return;
      }
      if (event.target.closest('[data-perfume-checkout-add]') && checkoutGuard) { event.preventDefault(); clearErrors(); checkoutGuard.accept(); return; }
      if (event.target.closest('[data-perfume-checkout-skip]') && checkoutGuard) { event.preventDefault(); checkoutGuard.skip(); return; }
      var trigger = event.target.closest('[data-perfume-open]');
      if (trigger) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); open('details', trigger); return;
      }
      if (event.target.closest('[data-perfume-close]')) { if (!checkoutBusy) close(); return; }
      var thumb=event.target.closest('[data-perfume-thumb]');
      if (thumb) {
        var image=dialog.querySelector('[data-perfume-image]'); image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.src=thumb.dataset.src; image.alt=thumb.dataset.alt;
        dialog.querySelectorAll('[data-perfume-thumb]').forEach(function (item) { item.setAttribute('aria-pressed',String(item===thumb)); }); return;
      }
      if (!event.target.closest('[data-perfume-add]')) return;
      event.preventDefault();
      clearErrors();
      controller.add().then(function (didAdd) { if (didAdd) close(); }).catch(showError);
    });
    return { update: function (cart) { controller.update(cart); if (checkoutGuard) checkoutGuard.update(cart); } };
  }
  if (typeof module === 'object' && module.exports) module.exports = { createController: createController, createCheckoutGuard: createCheckoutGuard };
  else global.EverlaPerfume = { init: init };
})(typeof window !== 'undefined' ? window : this);
